<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">BESS · Grün- und Graustrom</p>

      <h2 class="presentation-page__title">
        Batteriespeicher-Systeme als eigenständige Asset-Klasse
      </h2>

      <p class="presentation-page__text">
        BESS-Projekte bankfähig entwickeln, bauen und betreiben — als Stand-alone oder hybrid mit
        PV.
      </p>

      <div class="presentation-page__body presentation-page__body--split">
        <div class="presentation-page__column presentation-page__column--text">
          <ul class="presentation-page__list">
            <li v-for="item in listItems" :key="item">{{ item }}</li>
          </ul>
        </div>

        <div class="presentation-page__column presentation-page__column--stats">
          <div class="presentation-page__stat-cards">
            <article
              v-for="useCase in useCases"
              :key="useCase.label"
              :class="[
                'presentation-page__stat-card',
                'presentation-page__stat-card--compact',
                `presentation-page__stat-card--${useCase.accent}`,
              ]"
            >
              <p class="presentation-page__stat-label">{{ useCase.label }}</p>
              <p class="presentation-page__stat-detail">{{ useCase.detail }}</p>
            </article>
          </div>
        </div>
      </div>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage27',

  components: { PrintPageLandscape, PresentationPage },

  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },

  data() {
    return {
      listItems: [
        'Standort- und Projektentwicklung für eigenständige oder hybride BESS-Projekte bis zur Baureife',
        'Technische Systemauslegung von Batteriespeichern (Leistung, Kapazität, EMS) inkl. Umspannwerke und Netzanschluss',
        'Integration von BESS in bestehende oder neue PV- und Netzinfrastrukturen als ganzheitliches Energiesystem',
        'Planung und Umsetzung aller Schnittstellen zu Netzbetreibern, Leitstellen und Marktpartnern',
        'Eigenverantwortliche EPC-/Turnkey-Umsetzung inkl. Lieferung, Montage, Bau, Inbetriebnahme und technischer Abnahme',
        'Übergabe schlüsselfertiger, bankfähiger BESS-Anlagen inkl. vollständiger Dokumentation',
      ],
      useCases: [
        {
          accent: 'brand-primary',
          label: 'Arbitrage',
          detail: 'Strompreisschwankungen monetarisieren',
        },
        {
          accent: 'brand-teal',
          label: 'Frequenzregelung',
          detail: 'Primär- und Sekundärregelleistung',
        },
        {
          accent: 'brand-primary',
          label: 'Netzdienlichkeit',
          detail: 'Netzstabilisierung & Lastspitzenkappung',
        },
        {
          accent: 'brand-teal',
          label: 'Eigenverbrauch',
          detail: 'Hybrid mit PV für maximale Eigenquote',
        },
      ],
    };
  },
};
</script>
